import { supabase } from "@/utils/supabase";
import { VehicleManufacturerMapper } from "@/adapters/VehicleManufacturer.mapper";
export class VehicleManufacturerService {
    async getVehicleManufacturersWithParams(params) {
        try {
            let query = supabase()
                .from("vehicle_manufacturers")
                .select("*", { count: "exact" })
                .eq("is_deleted", false);
            // Фильтры
            if (params.filters) {
                const search = params.filters.search?.trim();
                if (search) {
                    const ors = [`name.ilike.*${search}*`];
                    query = query.or(ors.join(","));
                }
            }
            // Сортировка
            if (params.sorters && Object.keys(params.sorters).length > 0) {
                Object.entries(params.sorters).forEach(([field, order]) => {
                    if (order === "ascend")
                        query = query.order(field, { ascending: true });
                    else if (order === "descend")
                        query = query.order(field, { ascending: false });
                });
            }
            else {
                query = query.order("name", { ascending: true });
            }
            // Пагинация
            const from = (params.page - 1) * params.pageSize;
            query = query.range(from, from + params.pageSize - 1);
            const { data, error, count } = await query;
            if (error)
                throw error;
            return {
                data: data.map(VehicleManufacturerMapper.toDomain),
                total: count || 0,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            console.error("Error in getVehicleManufacturersWithParams:", error);
            throw error;
        }
    }
    async getVehicleManufacturersByIds(ids) {
        const { data, error } = await supabase()
            .from("vehicle_manufacturers")
            .select("*")
            .in("id", ids)
            .eq("is_deleted", false);
        if (error) {
            throw error;
        }
        return data.map(VehicleManufacturerMapper.toDomain);
    }
    async createVehicleManufacturer(vehicleManufacturerData) {
        try {
            const vehicleManufacturerDto = VehicleManufacturerMapper.toCreateDto(vehicleManufacturerData);
            const { data, error } = await supabase()
                .from("vehicle_manufacturers")
                .insert([vehicleManufacturerDto])
                .select()
                .single();
            if (error)
                throw error;
            return VehicleManufacturerMapper.toDomain(data);
        }
        catch (error) {
            console.error("Error creating vehicle manufacturer:", error);
            throw error;
        }
    }
    async updateVehicleManufacturer(id, vehicleManufacturerData) {
        try {
            const vehicleManufacturerDto = VehicleManufacturerMapper.toCreateDto(vehicleManufacturerData);
            const { data, error } = await supabase()
                .from("vehicle_manufacturers")
                .update(vehicleManufacturerDto)
                .eq("id", id)
                .select()
                .single();
            if (error)
                throw error;
            return VehicleManufacturerMapper.toDomain(data);
        }
        catch (error) {
            console.error("Error updating vehicle manufacturer:", error);
            throw error;
        }
    }
    async deleteVehicleManufacturer(id) {
        try {
            const { error } = await supabase()
                .from("vehicle_manufacturers")
                .update({
                is_deleted: true,
            })
                .eq("id", id);
            if (error)
                throw error;
        }
        catch (error) {
            console.error("Error deleting vehicle manufacturer:", error);
            throw error;
        }
    }
}
export const vehicleManufacturerService = new VehicleManufacturerService();
